import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const GithubSvg = ({ color = "primary", ...rest }) => {
  return (
    <Svg
      fill="none"
      width="33"
      height="33"
      viewBox="-5.5 -.5 26 16"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <Path
        fill={color}
        clip-rule="evenodd"
        d="m7.97553.191406c-4.40367 0-7.97553 3.571864-7.97553 7.975534 0 3.52296 2.29969 6.50766 5.43119 7.58406.39144.049.53823-.1957.53823-.3914s0-.685 0-1.37c-2.20184.4893-2.69113-1.0765-2.69113-1.0765-.34251-.9296-.88074-1.1743-.88074-1.1743-.73394-.4893.04893-.4893.04893-.4893.78288.0489 1.22324.8318 1.22324.8318.73395 1.2233 1.85933.8807 2.2997.685.04893-.5382.29358-.8807.4893-1.0764-1.76147-.1957-3.6208-.8808-3.6208-3.96333 0-.88073.29358-1.56574.8318-2.1529-.04892-.14679-.3425-.97859.09786-2.05505 0 0 .68502-.19572 2.20184.83181.63608-.19572 1.3211-.24465 2.00611-.24465.68502 0 1.37003.09786 2.00612.24465 1.51685-1.02753 2.20185-.83181 2.20185-.83181.4404 1.07646.1468 1.90826.0978 2.10398.4893.53823.8318 1.27217.8318 2.1529 0 3.0826-1.8593 3.7187-3.62075 3.9144.29358.2446.53825.7339.53825 1.4679v2.2018c0 .1957.1468.4404.5382.3914 3.1804-1.0764 5.4312-4.0611 5.4312-7.58406-.0489-4.40367-3.6208-7.975534-8.02447-7.975534z"
        fill-rule="evenodd"
      />
    </Svg>
  )
}

export default GithubSvg
